<!-- Struct 口径表格 类型: k -->
<!-- 复制出来的口径表格 以 key 为 键值-->
<template>
  <!-- <form> -->
  <div class="implement-caliber-field-wrap box mt24">
    <fieldset>
      <legend>
        <span class="title-item">{{caliberData.structName}}</span>
        <el-button size="mini" v-show="isEdit" type="text" @click="handleCopyCaliber">复制</el-button>
        <el-button v-show="canRename" size="mini" type="text" @click="handleRenameCaliber">重命名</el-button>
        <!-- <div v-show="isEdit" class="title-item copy-btn" @click="handleCopyCaliber">复制</div> -->
        <!-- <div v-show="canRename" class="title-item rename-btn" @click="handleRenameCaliber">重命名</div> -->
        <div class="log-icon" v-if="isEdit && caliberData.isCopy !== 1">
          <gov-caliber-log-popups
            @revert="handleRevertData"
            :household-id="householdId"
            :struct-id="caliberData.id"
            :project-id="projectId"
          ></gov-caliber-log-popups>
        </div>
      </legend>
      <center class="celiber-foot" v-if="!isEdit">评估总价：{{totalAmountValue}} 元</center>
      <el-table
        stripe
        class="caliber-table"
        border
        v-show="showTable"
        @cell-click="handleCellEnter"
        :data="localCaliberData.caliberDataList"
        v-loading="localCaliberData.tableLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="#ffffff"
      >
        <el-table-column label="操作" v-if="isEdit" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleAddCaliberRow">新增</el-button>
            <gov-delete-button
              v-show="isDeletable"
              @confirm="handleDeleteCaliberRow(scope.row)"
              label="删除"
            ></gov-delete-button>
            <!-- <el-button
                size="mini"
                type="text"
                @click="handleEditCaliberRow(scope.row)">
                {{scope.row.isEdit ? '编辑' : '完成'}}
            </el-button>-->
          </template>
        </el-table-column>
        <el-table-column label="口径类别" prop="caliberTypeId">
          <template slot-scope="scope">
            <el-select
              @focus="handleCellEnter(scope.row)"
              size="small"
              filterable
              @change="handleCaliberTypeChange"
              v-model="scope.row.caliberTypeId"
              :disabled="!isEdit"
            >
              <el-option
                v-for="option in (scope.row.caliberTypeList || [])"
                :key="option.id"
                :label="option.caliberTypeName"
                :value="option.caliberTypeId"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="项目" prop="caliberItemId">
          <template slot-scope="scope">
            <el-select
              @focus="handleCellEnter(scope.row)"
              size="small"
              filterable
              @change="handleCaliberProChange"
              v-model="scope.row.caliberItemId"
              :disabled="!isEdit"
            >
              <el-option
                v-for="option in scope.row.caliberProList"
                :key="option.id"
                :label="option.caliberItemName"
                :value="option.id"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="规格" prop="caliberSpecificationId">
          <template slot-scope="scope">
            <el-select
              @focus="handleCellEnter(scope.row)"
              size="small"
              @change="handleSpecificationChange"
              v-model="scope.row.caliberSpecificationId"
              :disabled="!isEdit"
            >
              <el-option
                v-for="option in scope.row.caliberSpecificationList"
                :key="option.id"
                :label="check(option.specification)"
                :value="option.id"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="单位" prop="unitName" width="50">
          <template slot-scope="scope">{{findUnitName(scope.row)}}</template>
        </el-table-column>
        <el-table-column label="过程" prop="process">
          <template slot-scope="scope">
            <el-input
              @focus="handleCellEnter(scope.row)"
              size="small"
              @blur="handleProcessChange(scope.row)"
              v-model="scope.row.process"
              :disabled="!isEdit"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label prop="equalStr" width="30">
          <template>
            <span>=</span>
          </template>
        </el-table-column>
        <el-table-column label="工程量" prop="workAmount">
          <template slot-scope="scope">
            <el-input size="small" v-model="scope.row.workAmount" disabled></el-input>
          </template>
        </el-table-column>
        <el-table-column label="单价" prop="changedPrice">
          <template slot-scope="scope">
            <el-input
              @focus="handleCellEnter(scope.row)"
              @change="handleClearPrice(scope.row)"
              size="small"
              v-model="scope.row.changedPrice"
              :disabled="!isEdit"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="总价" prop="totalAmount">
          <template slot-scope="scope">
            <el-input size="small" v-model="scope.row.totalAmount" disabled></el-input>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark">
          <template slot-scope="scope">
            <!-- <el-popover placement="top-start" width="200" :content="scope.row.remark"> -->
            <el-tooltip
              class="item"
              effect="light"
              :content="scope.row.remark"
              placement="right"
              width="200"
              :disabled="scope.row.remark === '' || scope.row.remark === null"
            >
              <el-input
                @focus="handleCellEnter(scope.row)"
                size="small"
                v-model="scope.row.remark"
                :disabled="!isEdit"
              ></el-input>
            </el-tooltip>
            <!-- </el-popover> -->
          </template>
        </el-table-column>
        <el-table-column label="成新率" min-width="130" prop="newnessRate">
          <template slot-scope="scope">
            <el-input-number
              :controls="false"
              size="small"
              v-model="scope.row.newnessRate"
              :disabled="!isEdit"
              @blur="calculateTotalPrice(scope.row)"
              :min="0"
              :max="100"
            ></el-input-number>
            <!-- <el-input size="small" @blur="calculateTotalPrice(scope.row)" v-model="scope.row.newnessRate" :disabled="!isEdit"> -->
            <!-- <el-input @focus="handleCellEnter(scope.row)" size="small" @blur="calculateTotalPrice(scope.row)" v-model="scope.row.newnessRate" :disabled="!isEdit">
                <template slot="append">%</template>
            </el-input>-->
          </template>
        </el-table-column>
      </el-table>
      <center class="celiber-foot">
        <span class="fold-btn" @click="handleFold">{{showText}}</span>
      </center>
    </fieldset>
    <!-- 重命名 -->
    <el-dialog
      title="重命名"
      width="500px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible"
      :before-close="handleCancelRename"
    >
      <el-form
        :model="formRename"
        size="small"
        class="demo-ruleForm"
        ref="rename"
        :rules="formRenameRule"
      >
        <el-form-item label="口径表格名称" label-width="120px" prop="name">
          <el-input v-model="formRename.name" autocomplete="off" placeholder="请输入口径表格名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCancelRename">取 消</el-button>
        <el-button size="small" type="primary" @click="handleSubmitRename">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 复制口径弹窗 -->
    <el-dialog
      title="复制"
      width="500px"
      custom-class="cliber-copy-form-wrap"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogCopyVisible"
      @close="handleCloseCopy"
    >
      <el-form ref="formCopy" size="small" :model="formCopy" :rules="formCopyRule">
        <el-row>
          <el-form-item label="口径表格名称" label-width="120px" prop="name">
            <el-input
              style="width: 217px;"
              v-model="formCopy.name"
              autocomplete="off"
              placeholder="请输入口径表格名称"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="复制类型" label-width="120px">
            <el-select v-model="formCopy.copyType" placeholder="复制类型">
              <el-option label="保留口径项及数据" :value="1"></el-option>
              <el-option label="仅保留口径项" :value="2"></el-option>
              <el-option label="不保留" :value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseCopy">取 消</el-button>
        <el-button size="small" type="primary" @click="handleSubmitCopy">确 定</el-button>
      </div>
    </el-dialog>
  </div>
  <!-- </form> -->
</template>

<script>
import { isUndef } from '@/untils/index';
// import GovCaliberLogPopups from './caliber-logs-popups';
export default {
  props: {
    caliberData: {
      type: Object,
      required: true
    },
    householdId: {
      type: String
    },
    projectId: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      required: true
    }
  },
  components: {},
  computed: {
    totalAmountValue() {
      let value = Number(this.localCaliberData.value);
      return value.toFixed(2);
    },
    isDeletable() {
      if (Array.isArray(this.localCaliberData.caliberDataList)) {
        return this.localCaliberData.caliberDataList.length > 1;
      }
      return false;
    },
    canRename() {
      return this.isEdit === true && this.localCaliberData.copySource !== '-1';
    }
  },
  watch: {
    caliberData: {
      deep: true,
      immediate: true,
      handler(val) {
        // if (Array.isArray(val.caliberDataList)) {
        //   val.caliberDataList.forEach(item => {
        //     item.key = this.key++;
        //   });
        // }
        this.localCaliberData = val;
      }
    }
  },
  data() {
    return {
      key: 1,
      localCaliberData: {},
      showTable: false,
      showText: '展开口径项',
      // 重命名
      dialogVisible: false,
      // 复制
      dialogCopyVisible: false,

      formRename: {
        name: ''
      },
      formRenameRule: {
        name: {
          required: true,
          message: '请输入口径表格名称'
        }
      },
      formCopy: {
        copyType: 1,
        name: ''
      },
      formCopyRule: {
        name: {
          required: true,
          message: '请输入口径表格名称'
        }
      },
      currentRow: {}, // 当前操作的数据
      delPopoverVisible: false
    };
  },
  methods: {
    handleFold() {
      if (this.showTable) {
        this.showTable = false;
        this.showText = '展开口径项';
      } else {
        this.$emit('query-data', this.localCaliberData.id);
        this.showText = '隐藏口径项';
        this.showTable = true;
      }
    },
    // 回退版本数据
    handleRevertData(data) {
      this.$emit('revert', data, this.localCaliberData.id);
    },
    // 口径类别改变
    handleCaliberTypeChange(caliberTypeId) {
      const row = this.currentRow;
      const { caliberTypeList } = row;
      row.caliberItemId = '';
      row.caliberSpecificationId = '';
      for (let ct of caliberTypeList) {
        if (ct.caliberTypeId === caliberTypeId) {
          row.caliberProList = ct.caliberProList;
        }
      }
    },
    // 口径项目改变
    handleCaliberProChange(caliberItemId) {
      const row = this.currentRow;
      row.caliberSpecificationId = '';
      const { caliberProList } = row;
      for (let cp of caliberProList) {
        if (cp.id === caliberItemId) {
          row.caliberSpecificationList = cp.caliberSpecificationDtos;
          row.caliberSpecificationId = cp.caliberSpecificationDtos[0].id;
          this.handleSpecificationChange(row.caliberSpecificationId);
        }
      }
    },
    // 单位
    findUnitName(row) {
      const { caliberSpecificationId } = row;
      // const crow = this.currentRow;
      let unitName = '';
      const { caliberSpecificationList } = row;
      if (Array.isArray(caliberSpecificationList)) {
        for (let cs of caliberSpecificationList) {
          if (cs.id === caliberSpecificationId) {
            unitName = cs.unitName || '个';
          }
        }
      }
      return unitName;
    },
    // 鼠标进入一行数据
    handleCellEnter(row) {
      if (this.currentRow === row) return false;
      this.currentRow = row;
    },
    // 编辑口径数据
    handleEditCaliberRow(row) {
      if (!this.currentRow.isEdit && row.key !== this.currentRow.key) {
        this.currentRow.isEdit = true;
      }
      if (row.isEdit) {
        row.isEdit = !row.isEdit;
      } else {
        const { process } = row;
        // let workAmount = 0;
        try {
          row.workAmount = window.eval(process);
          this.calculateTotalPrice(row);
          row.isEdit = !row.isEdit;
        } catch (e) {
          // row.process = '';
          this.$message.error('过程输入不正确，请检查！');
        }
      }
      this.$nextTick(() => {
        this.currentRow = row;
      });
    },
    // 获取商品价格
    handleSpecificationChange(caliberSpecificationId) {
      // const { caliberSpecificationId } = row;
      const row = this.currentRow;
      // let unitName = '';
      const { caliberSpecificationList } = row;
      for (let cs of caliberSpecificationList) {
        if (cs.id === caliberSpecificationId) {
          row.changedPrice = cs.price;
          this.calculateTotalPrice(row);
        }
      }
    },
    // 清空单价的时候则重新计算系统默认单价
    handleClearPrice(row) {
      const { caliberSpecificationId, changedPrice } = row;
      if (changedPrice === '') {
        this.handleSpecificationChange(caliberSpecificationId);
      } else {
        this.calculateTotalPrice(row);
      }
    },
    // 获取评估总价
    getTotalPrice() {
      let totalAmountValue = 0;
      const { caliberDataList } = this.localCaliberData;
      if (caliberDataList instanceof Array) {
        caliberDataList.forEach(item => {
          let total = parseFloat(item.totalAmount);
          if (Number.isNaN(total)) {
            total = 0;
          }
          totalAmountValue += total;
        });
      }
      return totalAmountValue.toFixed(2);
    },
    // 过程变化计算工程量
    handleProcessChange(row) {
      const { process } = row;
      // let workAmount = 0;
      try {
        let result = Number(window.eval(process));
        if (Number.isNaN(result)) {
          result = 0;
        }
        row.workAmount = result.toFixed(2);
        this.calculateTotalPrice(row);
      } catch (e) {
        row.process = 0;
        this.$message.error('不是有效的计算公式请重新输入，请检查！');
      }
    },
    // 计算总价
    calculateTotalPrice(row) {
      const { workAmount, changedPrice, newnessRate } = row;
      let result = (workAmount * changedPrice * newnessRate) / 100;
      if (Number.isNaN(result)) {
        result = 0;
      }
      row.totalAmount = result.toFixed(2);
    },

    // 复制
    handleCopyCaliber() {
      this.dialogCopyVisible = true;
    },
    // 关闭
    handleCloseCopy() {
      this.dialogCopyVisible = false;
      this.formCopy.copyType = 1;
      this.formCopy.name = '';
    },

    handleSubmitCopy() {
      this.$refs.formCopy.validate(valid => {
        if (valid) {
          // if (this.localCaliberData.id)
          const data = {
            copySource: this.localCaliberData.id,
            copyType: this.formCopy.copyType,
            caliberDataId: this.localCaliberData.id,
            copyStructName: this.formCopy.name
          };
          if (this.localCaliberData.copySource !== '-1') {
            data.copySource = this.localCaliberData.copySource;
          }
          this.$emit('copy', data, () => {
            this.dialogCopyVisible = false;
          });
        } else {
          return false;
        }
      });
    },
    // 口径表格新增行
    handleAddCaliberRow() {
      this.localCaliberData.caliberDataList.forEach(item => {
        item.key = this.key++;
      });
      const model = {
        caliberItemId: '',
        caliberSpecificationId: '',
        caliberTypeId: '',
        isEdit: true,
        caliberTypeList: [], // 口径类型
        caliberProList: [], // 口径项目数据
        caliberSpecificationList: [], // 口径规格
        changedPrice: 0,
        createTime: null,
        createUser: null,
        delFlag: null,
        householdId: null,
        id: '',
        newnessRate: 100,
        process: '',
        projectId: null,
        remark: '',
        templateParentStructId: '',
        totalAmount: 0,
        updateTime: null,
        updateUser: null,
        version: 0,
        workAmount: 0
      };
      model.key = this.key++;
      this.localCaliberData.caliberDataList.push(model);
      // this.caliberData = val;
      // this.addCaliberRowData({ caliberDataKey: this.localCaliberData.key });
    },

    // 口径表格删除行
    handleDeleteCaliberRow(row) {
      const { key } = row;
      this.localCaliberData.caliberDataList = this.localCaliberData.caliberDataList.filter(
        item => item.key !== key
      );
    },
    // 删除复制出来的口径数据
    handleDeleteCopyItem() {
      this.$emit('delete', this.localCaliberData.id);
    },
    handleDelCaliberRow(rowKey) {
      this.delCaliberRowData({
        rowKey,
        caliberDataKey: this.localCaliberData.key
      });
    },

    // 重命名
    handleRenameCaliber() {
      this.dialogVisible = true;
    },

    // 重命名取消
    handleCancelRename() {
      this.dialogVisible = false;
      this.$refs.rename.resetFields();
      this.formRename.name = '';
    },

    // 重命名确定
    handleSubmitRename() {
      this.$refs.rename.validate(valid => {
        if (valid) {
          this.$emit(
            're-name',
            {
              name: this.formRename.name,
              id: this.localCaliberData.id
            },
            () => {
              this.handleCancelRename();
            }
          );
        } else {
          return false;
        }
      });
    },
    check(specification) {
      if (!isUndef(specification)) {
        return specification;
      } else {
        return '\t';
      }
    }
  },
  created() {
    // if (this.isEdit) {
    //   this.showTable = true;
    // }
  }
};
</script>

<style>
.implement-caliber-field-wrap {
}
.box {
  /* border: 1px solid #e3e3e3; */
  position: relative;
  /* padding: 20px 10px 0 10px; */
}
.caliber-title {
  position: absolute;
  left: 20px;
  top: -10px;
  height: 20px;
  line-height: 20px;
  padding: 0 10px;
  background-color: #fff;
  display: flex;
}
.caliber-table {
  margin-bottom: 12px;
}
.celiber-foot {
  font-size: 13px;
  padding: 12px 0;
}
.fold-btn {
  cursor: pointer;
  color: #1f8f95;
  margin-left: 8px;
}
.mt24 {
  margin-top: 24px;
}

.el-input-group__append {
  padding: 0 8px;
}

.radio-group {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}
fieldset {
  min-width: 100px;
  border: 1px solid #e3e3e3;
  padding: 10px;
}
.ml0 {
  margin-left: 0 !important;
  margin-top: 8px;
}
.cliber-copy-form-wrap .el-form-item {
  margin-bottom: 22px;
}
.log-icon {
  display: inline-block;
}
.title-item {
  margin-right: 15px;
}
legend {
  padding: 0 10px;
  margin-left: 20px;
}
.copy-btn,
.rename-btn {
  cursor: pointer;
  color: #1f8f95;
}

.del-btn {
  cursor: pointer;
  color: #fa5b0a;
}
.title-item {
  margin-right: 8px;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/form-struct.caliber.vue